import { IFormPopupProps } from '@root/components/FormPopup/models';
import Joi from 'joi';

const uriRequired = Joi.string().uri().required();
const imgSchema = {
  url: uriRequired,
  filename: Joi.string().required(),
};
const requiredImageSchema = Joi.object(imgSchema).required();

export const formPopupSchema = Joi.object<IFormPopupProps>({
  title: Joi.string().required(),
  image: requiredImageSchema,
  formId: Joi.string().required(),
  closeBtn: Joi.string().required(),
  tyText: Joi.string().required(),
  tyImage: requiredImageSchema,
  isModalShowedOnlyOnce: Joi.boolean().required(),
  onCloseLocalStorageValue: Joi.string().required(),
  submitErrorMessage: Joi.string().required(),
  modalAppearingDelay: Joi.string().required(),
}).options({ stripUnknown: true });
